import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { sensitiveContentService } from '@/services/sensitive-content-service';
import type { SensitiveContentList } from '@/types/core/sensitive-content';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { sensitiveContentQueryKeys } from './query-keys';

/** List the tenant's live sensitive content; mount callers only once `sensitive_content:read` is held. */
export function useListSensitiveContent(
  tenantId: UUID
): UseQueryResult<SensitiveContentList, Error> {
  return useQuery<SensitiveContentList, Error>({
    queryKey: sensitiveContentQueryKeys.list(tenantId),
    queryFn: () => sensitiveContentService.list(tenantId),
    enabled: !isEmptyUUID(tenantId),
  });
}
